
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer von Geburt an blind ist, erlebt Träume anders als sehende Menschen – genau so, wie sie oder er die Welt auch im Wachzustand anders wahrnimmt. Die geburtsblinde Zürcher Sozialarbeiterin Andrea Blaser beschreibt es mit diesen Worten: «Ich träume so, wie ich lebe. Alle meine Sinne sind wach. Ich rieche, höre, schmecke und taste. Als geburtsblinde Frau weiss ich nicht, wie Sehen funktioniert, weder im Wach- noch im Traumzustand. Deshalb ist in meinen Träumen der Sehsinn nicht aktiv. Die Träume sind dennoch so vielfältig, wie ich sie mir bei sehenden Personen vorstelle. Auch in meinen Träumen versuche ich, davonzueilen – mit einer Blindenhündin, einem Langstock oder am Ellbogen eines anderen Menschen. So, wie ich es gewohnt bin.» `}<br /><br />{`
Auch Blinde benötigen die Träume, um die Erlebnisse des Tages zu verarbeiten oder sich auf bestimmte Situationen vorzubereiten. Je nachdem, wie intensiv die Träume waren, sind die Erinnerungen an sie mehr oder weniger vorhanden – genau gleich wie bei Menschen mit Augenlicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;